module.exports = __webpack_public_path__ + "static/img/logo.303bc79f.svg";